import React from "react";
import { ReferenciaContenido } from "../../../interfaces/ReferenciaContenido";

// Components //
import TitleSection from "../../molecules/title-section";
import Maps from "../../organisms/maps/maps";

// Styles //
import "./our-offices.scss";


const OurOffices = (props: ReferenciaContenido) => {

    const {
        tituloGeneral,
        descripcion,
    } = props;
    return (
        <div className="container">
            <div className="o-offices">
                <div className="o-offices__container">
                    <TitleSection
                        title={tituloGeneral}
                        introText={descripcion.raw? JSON.parse(descripcion.raw).content[0].content[0].value
                                    : descripcion.json.content[0].content[0].value}
                    />
                    <Maps
                        {...props}
                    />
                </div>
            </div>
        </div>
    );
};

export default OurOffices;
